import ColorInformer from './ColorInformer';

export default ColorInformer;